import { GROUPING_SAVE_KEY, useGroupingSetting } from "@/shared/list-filter/composables/grouping-settings.ts";
import { useGroupingStore } from "@/shared/grouping/store/grouping.store.ts";
import { watchImmediate } from "@vueuse/core";
import { computed } from "vue";

export const useGrouping = (key: GROUPING_SAVE_KEY) => {
    const store = useGroupingStore();
    const { isGrouped: saved, save, initialized } = useGroupingSetting(key);

    // the saved preference is applied once - a later instance must not overwrite the current state
    watchImmediate(initialized, (done) => {
        if (!done || store.isGrouped[key] !== undefined) return;
        store.setIsGrouped(key, saved.value);
    });

    const isGrouped = computed({
        get: () => store.isGrouped[key] ?? false,
        set: async (value) => {
            store.setIsGrouped(key, value);
            await save(value);
        },
    });

    return { isGrouped };
};
